import IDisplayManager, { TDisplay } from './IDisplayManager';

export default class MockDisplayManager implements IDisplayManager {
	public async isSerialConnectionAvailable(): Promise<boolean> {
		return true;
	}
	public async sendCommand(_command: number, _values?: [number]): Promise<void> {
		return Promise.resolve();
	}
	public async getConnectedDisplay(): Promise<TDisplay> {
		return 'DEFAULT_DISPLAY' as any;
	}
}
